module.exports = __webpack_public_path__ + "img/outing.cba600f0.png";